import React, { useEffect, useState } from "react";
import "./styled.css";
//redux
import { connect } from "react-redux";
//tags
import MetaTags from "react-meta-tags";
import { setAdminPlusRankingPoints } from "../../../utils/service/ranking";

import OptionBaby from "./optionBaby";
import OptionJunior from "./optionJunior";
import OptionTeen from "./optionTeen";

function MascotHouse(props) {
  const [step, setStep] = useState("");

  function pointAction(type) {
    setAdminPlusRankingPoints(
      type,
      props.state.user.registration,
      "c90a159e-e538-43d3-a66b-82292586912f"
    );
  }

  useEffect(() => {
    document.getElementById("title-mascot").focus();
    props.loadingUserOff();
  }, []);
  return (
    <section className="section-mascotHouse" id="section-mascotHouse">
      <MetaTags>
        <title>Digital Lovers Festival - Página Casa do Mascote</title>
      </MetaTags>
      <a id="title-mascot" className="title-home" tabIndex={12}>
        Página Casa do Mascote
      </a>
      <div className="div-cards-centers">
        <div className="card-centers">
          <a className="title-card-centers" tabIndex={13}>
            Baby
          </a>
          <video
            width={250}
            controls
            tabIndex={14}
            onPlay={() => pointAction("CASADOMASCOTEBABY")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/MASCOTE/MASCOTE%20-%20BABY%20AUDIODESCRI%C3%87%C3%83O.mp4" />
          </video>
        </div>

        <div className="card-centers">
          <a className="title-card-centers" tabIndex={13}>
            Júnior
          </a>
          <video
            width={250}
            controls
            tabIndex={14}
            onPlay={() => pointAction("CASADOMASCOTEJUNIOR")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/MASCOTE/MASCOTE%20-%20JUNIOR%20AUDIODESCRI%C3%87%C3%83O.mp4" />
          </video>
        </div>

        <div className="card-centers">
          <a className="title-card-centers" tabIndex={13}>
            Teen
          </a>
          <video
            width={250}
            controls
            tabIndex={14}
            onPlay={() => pointAction("CASADOMASCOTETEEN")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/MASCOTE/MASCOTE%20-%20TEEN%20AUDIODESCRI%C3%87%C3%83O.mp4" />
          </video>
        </div>
      </div>
    </section>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

const mapDispatchToProps = function (dispatch) {
  return {
    loadingUserOff: (data) => {
      return dispatch({ type: "LOGIN_NAVIGATION_OFF", data });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MascotHouse);
